// extracted by mini-css-extract-plugin
export default {"wrapper":"style_wrapper__M2lOR","list":"style_list__dkPsM"};